import { render, staticRenderFns } from "./Footer02.vue?vue&type=template&id=88c4516e&"
import script from "./Footer02.vue?vue&type=script&lang=js&"
export * from "./Footer02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports